import { Spinner } from "@blueprintjs/core"
import NoResults from "components/Organisms/NoResults"
import { useFetchSurveyAreaVendors } from "graphql/routes/routes.hooks"
import React from "react"
import { InView } from "react-intersection-observer"
import OutletInfoCard from "./OutletInfoCard"

type OutletListProps = {
  notFoundMessage?: string
  fetchData?: boolean
  disabled?: boolean
}
const OutletList = ({
  notFoundMessage = "Please make sure you have selected a survey area (Route Details -> Survey Area)",
  fetchData = true,
  disabled = false,
}: OutletListProps) => {
  const {
    allOutlets,
    response: { loading },
  } = useFetchSurveyAreaVendors(fetchData)

  if (!loading && !allOutlets.length)
    return (
      <NoResults
        icon="cross"
        description={notFoundMessage}
        title="Unable to find the vendors"
      />
    )

  return (
    <InView onChange={() => {}}>
      {allOutlets.map(item => (
        <div
          key={item.id}
          className="bg-white rounded mb-2 shadow-sm select-none"
        >
          <OutletInfoCard
            isSelectable={disabled ? false : true}
            outlet={item}
          />
        </div>
      ))}
      {loading && <Spinner />}
    </InView>
  )
}

export default OutletList
